import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { BRAND } from "@/config/brand";

export default function Cookies() {
    return (
        <div>
            <PageMeta title="Cookie Policy — YS Removals" description="How YS Removals uses cookies on ysremovals.com." canonical={`https://${BRAND.domain}/cookie-policy`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Cookie Policy" }]} />
                    <h1 className="mt-3 text-4xl font-semibold font-heading">Cookie Policy</h1>
                </div>
            </section>
            <section className="container-ys section prose prose-neutral max-w-3xl">
                <p>We use cookies to make our site work and to improve your experience. You can control which categories are set using the cookie banner.</p>
                <h2>Cookie categories</h2>
                <ul>
                    <li><strong>Essential</strong> — required for the site to function correctly.</li>
                    <li><strong>Analytics</strong> — help us understand how the site is used (only loaded with your consent).</li>
                    <li><strong>Marketing</strong> — measure advertising effectiveness (only loaded with your consent).</li>
                </ul>
                <h2>Managing preferences</h2>
                <p>You can change your preferences at any time by clearing your browser storage for this site to re-open the cookie banner.</p>
            </section>
        </div>
    );
}
